"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProductListingPageAnalyticsController_1 = __importDefault(require("./tracking/ProductListingPageAnalyticsController"));
var ProductDetailsPageAnalyticsController_1 = __importDefault(require("./tracking/ProductDetailsPageAnalyticsController"));
var DatalayerManagement_1 = __importDefault(require("./tracking/DatalayerManagement"));
var ProductSearchPageAnalyticsController_1 = __importDefault(require("./tracking/ProductSearchPageAnalyticsController"));
var EmptyAnalyticsController_1 = __importDefault(require("./tracking/EmptyAnalyticsController"));
function initializeTracking(component, countryCode, language) {
    var datalayerManager = new DatalayerManagement_1.default(countryCode, language);
    switch (component) {
        case "ProductSearchPageRent" /* Component.PRODUCT_SEARCH_PAGE_RENT */:
        case "ProductSearchPageAcs" /* Component.PRODUCT_SEARCH_PAGE_LONG_TERM */:
            return new ProductSearchPageAnalyticsController_1.default(datalayerManager);
        case "ProductFavoritesPageLongTerm" /* Component.PRODUCT_FAVORITES_PAGE_LONG_TERM */:
        case "CarComparePageLongTerm" /* Component.PRODUCT_CAR_COMPARE_PAGE_LONG_TERM */:
        case "ProductListingPageRent" /* Component.PRODUCT_LISTING_PAGE_RENT */:
        case "ProductListingPageAcs" /* Component.PRODUCT_LISTING_PAGE_LONG_TERM */:
            return new ProductListingPageAnalyticsController_1.default(datalayerManager);
        case "ProductDetailPageAcs" /* Component.PRODUCT_DETAIL_PAGE_LONG_TERM */:
        case "ProductDetailPageRent" /* Component.PRODUCT_DETAIL_PAGE_RENT */:
            return new ProductDetailsPageAnalyticsController_1.default(datalayerManager);
        case "VehicleSummaryPage" /* Component.VEHICLE_SUMMARY_PAGE */:
            return new EmptyAnalyticsController_1.default(datalayerManager);
    }
}
function onDocumentTitleChange(title) {
    if (title) {
        document.title = title;
    }
}
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('div.js-react-init[data-config]').forEach(function (plp) {
        var conf = JSON.parse(plp.dataset.config);
        var trackingFunction = initializeTracking(conf.component, conf.isoCountryCode, conf.isoLanguageCode).track;
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
        AdvancedCarSearchReact.Initialize(plp.dataset.id, conf, trackingFunction, onDocumentTitleChange);
    });
});
